export const LAYOUT_TYPE_PINBOARD = 0;
export const LAYOUT_TYPE_CLASSIC = 1;



// WEBPACK FOOTER //
// ./app/constants/layout-types.js